import { createContext, useContext, useState } from "react";

type AppContextProps = {
  cartItemCount: number;
  setCartItemCount: (count: number) => void;
};

const AppContext = createContext<AppContextProps | null>(null);

export function AppProvider({ children }: { children: React.ReactNode }) {
  const [cartItemCount, setCartItemCount] = useState(0);

  const handleSetCartItemCount = (itemCount: number) => {
    setCartItemCount(itemCount);
  };

  return (
    <AppContext.Provider
      // eslint-disable-next-line react/jsx-no-constructed-context-values
      value={{
        cartItemCount,
        setCartItemCount: handleSetCartItemCount,
      }}
    >
      {children}
    </AppContext.Provider>
  );
}

export function useAppContext() {
  return useContext(AppContext);
}
